import CreateAssetPromotion from './CreateAssetPromotion';

export default CreateAssetPromotion;